// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1tlMG","title":"ClientInsurance_title__2mQbD","itemText":"ClientInsurance_itemText__3lIg-"};